import { asCurrency } from '../utils/formatters';
import { avg, last, sum } from '../utils/aggregators';
import { negate } from '../utils/transforms';
import { useFilterContext } from '../contexts/FilterContext';

const YearInfo = () => {
  const { years } = useFilterContext().state;
  return `(${years} yr)`;
};

export default [
  {
    displayName: 'Gross Income',
    accessor: 'grossIncomeEbit',
    aggregator: avg,
    color: 'var(--overyield-green)',
    defaultShown: true,
    format: asCurrency,
    yAxisId: 'currency',
    info: '(Avg/yr)',
  },
  {
    displayName: 'Cumulative Gross Income',
    accessor: 'cumulativeGrossIncome',
    aggregator: last,
    color: '#0091FF',
    defaultShown: true,
    format: asCurrency,
    yAxisId: 'currency',
    info: <YearInfo />,
  },
  {
    displayName: 'Revenue',
    accessor: 'revenueByYear',
    aggregator: avg,
    color: '#808000',
    format: asCurrency,
    yAxisId: 'currency',
    info: '(Avg/yr)',
  },
  {
    displayName: 'CapEx',
    accessor: 'capexAndGeneticsCostByYear',
    aggregator: sum,
    color: '#f032e6',
    format: asCurrency,
    yAxisId: 'currency',
    transform: negate,
    info: '(Total)',
  },
  {
    displayName: 'OpEx',
    accessor: 'operationCostByYear',
    aggregator: avg,
    color: '#800000',
    format: asCurrency,
    yAxisId: 'currency',
    info: '(Avg/yr)',
    transform: negate,
  },
];
